<template>
    <password
        v-model="password"
        defaultClass="form-control password-meter"
        :name="id"
        :placeholder="placeholder"
        :id="id"
        :toggle="true"
        :secureLength="minimalCharCount"
    />
</template>

<script>
import Password from 'vue-password-strength-meter'
import axios from 'axios'

export default {
    components: {
        Password
    },

    props: {
        'id': String,
        'placeholder': String,
        'minimalCharCount': Number,
        'required': {
            type: Boolean,
            default: true
        },
        'suggestion': '',
        'suggestionUrlJs': ''
    },

    data() {
        return {
            password: null,
            pwSuggestion: this.suggestion,
        };
    },

    mounted: function () {
        if (!this.required) {
            document.getElementById(this.id).removeAttribute('required');
        }
        let psm = this;
        $('#' + this.id)[0].suggest = function () {
            psm.suggest();
        }
    },

    methods: {
        getSuggestionUrl() {
            var f = eval(this.suggestionUrlJs);
            return typeof (f) === 'function' ? f() : '';
        },

        suggest() {
            if (this.pwSuggestion !== '') {
                this.password = this.pwSuggestion
            }
            var url = this.getSuggestionUrl();
            if (url) {
                axios.get(url).then(response => {
                    if (response.data.success) {
                        this.pwSuggestion = response.data.suggestion;
                    }
                });
            }
        }
    },

}
</script>

<style scoped>
    .Password {
        max-width: none;
    }

    .Password >>> .Password__badge, .Password >>> .Password__toggle {
        margin-right: 1rem;
    }

    .Password >>> .Password__badge {
        border-radius: .3rem;
        padding: .2rem;
        width: 2rem;
        height: 1.4rem;
        font-size: 1rem;
        text-align: center;
    }
</style>
